
<template>
  <div>
    <v-subheader>Necessário foto?</v-subheader>
    <v-sheet class="ml-2" max-width="1000" >
      <v-slide-group mandatory v-model="newItem.photo" center-active show-arrows="desktop">
        <v-slide-item :value="kind.kind" v-for="(kind,idx) in photo_options" :key="'ckind5'+idx" v-slot:default="{ active, toggle }">
          <v-btn class="mr-1" depressed rounded :input-value="active" @click="toggle"
            active-class="secondary darken-1 white--text"
          >
            <v-icon left>{{kind.icon}}</v-icon>{{kind.name}}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    is_flow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      newItem: this.$attrs.newItem,
      allKindPhoto: [
        {name: 'Não', kind: '0', icon:'mdi-close'},
        {name: 'Apenas para inconformidades', kind: '1', icon:'mdi-check'},
        {name: 'Sim, sempre', kind: '2', icon:'mdi-check-all'},
        {name: 'Sim, opcional', kind: '3', icon:'mdi-check-outline'},
      ],
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    flow_config(){
      if (this.is_flow && this.one_flow) {
        return this.one_flow.json_attributes
      }
      return null
    },
    photo_options(){
      if (this.is_flow && this.flow_config) {
        const {photos} = this.flow_config.step_item_config
        return this.allKindPhoto.filter(({kind})=> photos.includes(kind))
      } else {
        return this.allKindPhoto
      }
    },
    ...mapState({
      one_flow: state => state.ConfigFlow.one_flow,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>